module.exports = __webpack_public_path__ + "img/ivana-squares.ed6a0d05.jpg";